import { useMemo, useState } from "react"
import { isLoading } from "../component/loading/store"
import { useSelector } from "react-redux"
import { Box, Stack, Tab, Tabs } from "@mui/material"
import { isSameMonth, parseISO, subMonths } from "date-fns"
import ListCustomer from "./list"
import CustomerCard from "./CustomerCard"
import CustomerSkeleton from "./CustomerSkeleton"
import CustomerListSkeleton from "./list/CustomerListSkeleton"
import CustomerTable from "./CustomerTable"
import useTrademarkListFilter from "../../hooks/useTrademarkListFilter"

export default function Customer() {
    const loading = useSelector((state) => isLoading(state, "KPI_CUSTOMER"))
    const listAllSalesCustomer = useSelector((state) => state.kpiCustomer.listAllSalesCustomer)
    const selectedDate = useSelector((state) => state.kpiCustomer.selectedDate)
    const selectedTrademarks = useSelector((state) => state.trademark.selecteds)

    // faz o filtro das listas de clientes por marca selecionada pelo usuário
    const filteredListAllSalesCustomer = useTrademarkListFilter(listAllSalesCustomer)

    const currentDate = useMemo(() => new Date(selectedDate), [selectedDate])
    const lastMonthDate = useMemo(() => subMonths(currentDate, 1), [currentDate])

    const [tab, setTab] = useState(0)

    function filterSalesByMonth(list, referenceDate) {
        return list.filter(item => item.dataSaidaEntrada && isSameMonth(parseISO(item.dataSaidaEntrada), referenceDate))
    }

    function filterSalesNewCustomersLastMonth(sales, customers) {
        const ids = new Set(customers.map(c => c.idPessoa))
        return sales.filter(item => item.dataSaidaEntrada && isSameMonth(parseISO(item.dataSaidaEntrada), lastMonthDate) && ids.has(item.idPessoa))
    }

    function findNewCustomersByMonth(list, referenceDate) {
        const map = new Map()

        list.forEach(item => {
            if (!item.createdAt) return

            if (isSameMonth(parseISO(item.createdAt), referenceDate)) {
                map.set(item.idPessoa, item)
            }
        })

        return Array.from(map.values())
    }

    function filterSalesByCustomers(sales, customers) {
        const ids = new Set(customers.map(c => c.idPessoa))
        return sales.filter(sale => ids.has(sale.idPessoa))
    }

    const kpiCustomerData = useMemo(() => {
        // mês atual
        const currentMonthNewCustomers = findNewCustomersByMonth(filteredListAllSalesCustomer, currentDate)
        const currentMonthAllCustomersSales = filterSalesByMonth(filteredListAllSalesCustomer, currentDate)
        const currentMonthNewCustomersSales = filterSalesByCustomers(filteredListAllSalesCustomer, currentMonthNewCustomers)

        // Mês Anterior
        const lastMonthNewCustomers = findNewCustomersByMonth(filteredListAllSalesCustomer, lastMonthDate)
        const lastMonthSalesAllCustomers = filterSalesByMonth(filteredListAllSalesCustomer, lastMonthDate)
        const lastMonthSalesNewCustomers = filterSalesNewCustomersLastMonth(filteredListAllSalesCustomer, lastMonthNewCustomers)

        return {
            currentMonthNewCustomers,
            currentMonthNewCustomersSales,
            currentMonthAllCustomersSales,
            lastMonthNewCustomers,
            lastMonthSalesAllCustomers,
            lastMonthSalesNewCustomers
        }
        // eslint-disable-next-line
    }, [filteredListAllSalesCustomer, currentDate, lastMonthDate])

    return (
        <>
            <Tabs
                value={tab}
                onChange={(_, newValue) => setTab(newValue)}
                sx={{ borderBottom: 1, borderColor: "divider", mx: 0.5 }}
            >
                <Tab label="Visão geral" />
                <Tab label="Listagem" />
            </Tabs>

            {tab === 0 && (
                <>
                    {loading ? (
                        <CustomerSkeleton />
                    ) : (
                        <Stack sx={{ gap: 1.5, mt: 1.5 }}>
                            <CustomerCard
                                currentMonthNewCustomers={kpiCustomerData.currentMonthNewCustomers}
                                currentMonthNewCustomersSales={kpiCustomerData.currentMonthNewCustomersSales}
                                currentMonthAllCustomersSales={kpiCustomerData.currentMonthAllCustomersSales}
                                lastMonthNewCustomers={kpiCustomerData.lastMonthNewCustomers}
                                lastMonthSalesAllCustomers={kpiCustomerData.lastMonthSalesAllCustomers}
                                lastMonthSalesNewCustomers={kpiCustomerData.lastMonthSalesNewCustomers}
                            />
                            <CustomerTable currentMonthAllCustomersSales={kpiCustomerData.currentMonthAllCustomersSales} />
                        </Stack>
                    )}
                </>
            )}

            {tab === 1 && (
                <>
                    {loading ? (
                        <CustomerListSkeleton />
                    ) : (
                        <Box sx={{ mt: 2 }}>
                            <ListCustomer data={filteredListAllSalesCustomer} />
                        </Box>
                    )}
                </>
            )}
        </>
    )
}